import { useTranslation } from 'react-i18next';
import { useTripContext } from './TripDetailPage';
import { useAiPanel } from '../../components/ai/AiPanelContext';
import ServicesConnectivity from '../../components/services/ServicesConnectivity';

export default function ServicesTab() {
  const { trip } = useTripContext();
  // No specialist here, but gIA is on every tab: it answers with no hint.
  useAiPanel({ context: 'general' });
  const { t } = useTranslation();

  return (
    <div className="flex flex-col h-full overflow-hidden animate-fade-in">

      {/* ── Header ──────────────────────────────────────────────────────────── */}
      <div className="shrink-0 px-4 md:px-8 pt-5 pb-4 bg-white dark:bg-slate-900 border-b border-slate-100 dark:border-slate-800">
        <p className="font-mono text-[10px] tracking-[0.14em] uppercase text-slate-400 mb-0.5">
          {trip.destination.toUpperCase()}
        </p>
        <h2 className="font-serif italic font-semibold text-2xl md:text-3xl text-slate-900 dark:text-slate-100">
          {t('services.title')}
        </h2>
      </div>

      {/* ── Content ─────────────────────────────────────────────────────────── */}
      <div className="flex-1 overflow-auto px-4 md:px-8 py-6 md:py-8">
        <div className="max-w-2xl">
          <ServicesConnectivity destination={trip.destination} />
        </div>
      </div>
    </div>
  );
}
